export default __webpack_public_path__ + "static/media/4.80e07b52.jpg";